import React from 'react';

import { DEFAULT_ICON_PROPS, IIconProps } from './constants';

export const ErrorCheckoutIcon = ({ ariaLabel = 'Checkout error', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size || width}
      height={size || height}
      viewBox={`0 0 ${size || width} ${size || height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 52C0 23.326 23.328 0 52 0C80.672 0 104 23.326 104 52C104 80.674 80.672 104 52 104C23.328 104 0 80.674 0 52ZM4 52C4 78.466 25.534 100 52 100C78.466 100 100 78.466 100 52C100 25.534 78.466 4 52 4C25.534 4 4 25.534 4 52Z"
        fill="#FF261A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52 49.6085L37.6459 34.7902C36.9147 34.0288 35.661 33.9608 34.8384 34.6375C34.0179 35.3106 33.9443 36.4747 34.6735 37.2324L49.2677 52.4292L34.3766 67.802C34.0163 68.2214 34.1155 69.4672 34.7932 70.0378C35.4709 70.6084 37.1447 70.7435 37.5361 70.3353L52 55.2743L66.4638 70.3353C66.8552 70.7435 68.529 70.6084 69.2067 70.0378C69.8844 69.4672 69.9836 68.2214 69.6233 67.802L54.7322 52.4292L69.3264 37.2324C70.0556 36.4747 69.9821 35.3106 69.1615 34.6375C68.3389 33.9608 67.0852 34.0288 66.354 34.7902L52 49.6085Z"
        fill="#FF261A"
      />
    </svg>
  );
};
